import { mathml as p, svg as S, html as v } from "../beacon-html.d/index.js";
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const u = Symbol.for(""), d = (t) => {
  if ((t == null ? void 0 : t.r) === u) return t == null ? void 0 : t._$litStatic$;
}, w = (t) => ({ _$litStatic$: t, r: u }), _ = (t, ...a) => ({ _$litStatic$: a.reduce((l, i, o) => l + ((e) => {
  if (e._$litStatic$ !== void 0) return e._$litStatic$;
  throw Error(`Value passed to 'literal' function must be a 'literal' result: ${e}. Use 'unsafeStatic' to pass non-literal values, but
            take care to ensure page security.`);
})(i) + t[o + 1], t[0]), r: u }), m = /* @__PURE__ */ new Map(), c = (t) => (a, ...l) => {
  const i = l.length;
  let o, e;
  const r = [], $ = [];
  let n, s = 0, f = !1;
  for (; s < i; ) {
    for (n = a[s]; s < i && (e = l[s], (o = d(e)) !== void 0); ) n += o + a[++s], f = !0;
    s !== i && $.push(e), r.push(n), s++;
  }
  if (s === i && r.push(a[i]), f) {
    const h = r.join("$$lit$$");
    (a = m.get(h)) === void 0 && (r.raw = r, m.set(h, a = r)), l = $;
  }
  return t(a, ...l);
}, b = c(v), x = c(S), y = c(p);
export {
  b as html,
  _ as literal,
  y as mathml,
  x as svg,
  w as unsafeStatic,
  c as withStatic
};
